import { Schemas } from 'vscode/vscode/vs/base/common/network';
import { isWindows, isIOS } from 'vscode/vscode/vs/base/common/platform';
import { URI } from 'vscode/vscode/vs/base/common/uri';
import './media/scrollbar.css.js';
import './media/terminal.css.js';
import './media/terminalVoice.css.js';
import './media/widgets.css.js';
import './media/xterm.css.js';
import { localizeWithPath, localize2WithPath } from 'vscode/vscode/vs/nls';
import { CONTEXT_ACCESSIBILITY_MODE_ENABLED } from 'vscode/vscode/vs/platform/accessibility/common/accessibility';
import { CommandsRegistry } from 'vscode/vscode/vs/platform/commands/common/commands';
import { ContextKeyExpr } from 'vscode/vscode/vs/platform/contextkey/common/contextkey';
import { Extensions as Extensions$1 } from 'vscode/vscode/vs/platform/dnd/browser/dnd';
import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { KeybindingsRegistry } from 'vscode/vscode/vs/platform/keybinding/common/keybindingsRegistry';
import { Extensions } from 'vscode/vscode/vs/platform/quickinput/common/quickAccess';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import '../../../../platform/terminal/common/terminalLogService.js';
import { registerTerminalPlatformConfiguration } from '../../../../platform/terminal/common/terminalPlatformConfiguration.js';
import { EditorPaneDescriptor } from 'vscode/vscode/vs/workbench/browser/editor';
import { ViewPaneContainer } from 'vscode/vscode/vs/workbench/browser/parts/views/viewPaneContainer';
import { getQuickNavigateHandler } from 'vscode/vscode/vs/workbench/browser/quickaccess';
import { registerWorkbenchContribution2 } from 'vscode/vscode/vs/workbench/common/contributions';
import { EditorExtensions } from 'vscode/vscode/vs/workbench/common/editor';
import { Extensions as Extensions$2 } from 'vscode/vscode/vs/workbench/common/views';
import { RemoteTerminalBackendContribution } from './remoteTerminalBackend.js';
import { terminalEditorId } from 'vscode/vscode/vs/workbench/contrib/terminal/browser/terminal';
import { registerTerminalActions, terminalSendSequenceCommand } from './terminalActions.js';
import { setupTerminalCommands } from './terminalCommands.js';
import './terminalConfigurationService.js';
import { TerminalEditor } from './terminalEditor.js';
import { TerminalEditorInput } from 'vscode/vscode/vs/workbench/contrib/terminal/browser/terminalEditorInput';
import { TerminalInputSerializer } from './terminalEditorSerializer.js';
import './terminalEditorService.js';
import './terminalGroupService.js';
import { terminalViewIcon } from './terminalIcons.js';
import './terminalInstanceService.js';
import { TerminalMainContribution } from './terminalMainContribution.js';
import { setupTerminalMenus } from './terminalMenus.js';
import './terminalProfileService.js';
import { TerminalQuickAccessProvider } from './terminalQuickAccess.js';
import './terminalService.js';
import { TerminalViewPane } from './terminalView.js';
import { TerminalWslRecommendationContribution } from './terminalWslRecommendationContribution.js';
import { TERMINAL_VIEW_ID } from 'vscode/vscode/vs/workbench/contrib/terminal/common/terminal';
import { registerColors } from 'vscode/vscode/vs/workbench/contrib/terminal/common/terminalColorRegistry';
import { registerTerminalConfiguration } from '../common/terminalConfiguration.js';
import { TerminalContextKeys } from 'vscode/vscode/vs/workbench/contrib/terminal/common/terminalContextKey';
import { terminalStrings } from '../common/terminalStrings.js';

const _moduleId = "vs/workbench/contrib/terminal/browser/terminal.contribution";
const quickAccessRegistry = (( (Registry.as(Extensions.Quickaccess))));
const inTerminalsPicker = 'inTerminalPicker';
quickAccessRegistry.registerQuickAccessProvider({
    ctor: TerminalQuickAccessProvider,
    prefix: TerminalQuickAccessProvider.PREFIX,
    contextKey: inTerminalsPicker,
    placeholder: ( localizeWithPath(_moduleId, 0, "Type the name of a terminal to open.")),
    helpEntries: [{ description: ( localizeWithPath(_moduleId, 1, "Show All Opened Terminals")), commandId: "workbench.action.quickOpenTerm"  }]
});
const quickAccessNavigateNextInTerminalPickerId = 'workbench.action.quickOpenNavigateNextInTerminalPicker';
CommandsRegistry.registerCommand({ id: quickAccessNavigateNextInTerminalPickerId, handler: getQuickNavigateHandler(quickAccessNavigateNextInTerminalPickerId, true) });
const quickAccessNavigatePreviousInTerminalPickerId = 'workbench.action.quickOpenNavigatePreviousInTerminalPicker';
CommandsRegistry.registerCommand({ id: quickAccessNavigatePreviousInTerminalPickerId, handler: getQuickNavigateHandler(quickAccessNavigatePreviousInTerminalPickerId, false) });
registerWorkbenchContribution2(TerminalMainContribution.ID, TerminalMainContribution, 1 );
registerWorkbenchContribution2(RemoteTerminalBackendContribution.ID, RemoteTerminalBackendContribution, 3 );
registerWorkbenchContribution2(TerminalWslRecommendationContribution.ID, TerminalWslRecommendationContribution, 4 );
registerTerminalPlatformConfiguration();
registerTerminalConfiguration();
( (Registry.as(EditorExtensions.EditorFactory))).registerEditorSerializer(TerminalEditorInput.ID, TerminalInputSerializer);
( (Registry.as(EditorExtensions.EditorPane))).registerEditorPane(EditorPaneDescriptor.create(TerminalEditor, terminalEditorId, terminalStrings.terminal), [
    ( (new SyncDescriptor(TerminalEditorInput)))
]);
( (Registry.as(Extensions$1.DragAndDropContribution))).register({
    dataFormatKey: "Terminals" ,
    getEditorInputs(data) {
        const editors = [];
        try {
            const terminalEditors = JSON.parse(data);
            for (const terminalEditor of terminalEditors) {
                editors.push({ resource: ( (URI.parse(terminalEditor))) });
            }
        }
        catch (error) {
        }
        return editors;
    },
    setData(resources, event) {
        const terminalResources = resources.filter(({ resource }) => resource.scheme === Schemas.vscodeTerminal);
        if (terminalResources.length) {
            event.dataTransfer?.setData("Terminals" , JSON.stringify(( (terminalResources.map(({ resource }) => ( (resource.toString())))))));
        }
    }
});
const VIEW_CONTAINER = ( (Registry.as(Extensions$2.ViewContainersRegistry))).registerViewContainer({
    id: TERMINAL_VIEW_ID,
    title: ( localize2WithPath(_moduleId, 2, "Terminal")),
    icon: terminalViewIcon,
    ctorDescriptor: ( (new SyncDescriptor(
        ViewPaneContainer,
        [TERMINAL_VIEW_ID, { mergeViewWithContainerWhenSingleView: true }]
    ))),
    storageId: TERMINAL_VIEW_ID,
    hideIfEmpty: true,
    order: 3,
}, 1 , { doNotRegisterOpenCommand: true, isDefault: true });
( (Registry.as(Extensions$2.ViewsRegistry))).registerViews([{
        id: TERMINAL_VIEW_ID,
        name: ( localize2WithPath(_moduleId, 2, "Terminal")),
        containerIcon: terminalViewIcon,
        canToggleVisibility: false,
        canMoveView: true,
        ctorDescriptor: ( (new SyncDescriptor(TerminalViewPane))),
        when: TerminalContextKeys.processSupported,
        openCommandActionDescriptor: {
            id: "workbench.action.terminal.toggleTerminal" ,
            mnemonicTitle: ( localizeWithPath(_moduleId, 3, "&&Terminal")),
            keybindings: {
                primary: 2048  | 91 ,
                mac: { primary: 256  | 91  }
            },
            order: 3
        }
    }], VIEW_CONTAINER);
registerTerminalActions();
function registerSendSequenceKeybinding(text, rule) {
    KeybindingsRegistry.registerCommandAndKeybindingRule({
        id: "workbench.action.terminal.sendSequence" ,
        weight: 200 ,
        when: rule.when || TerminalContextKeys.focus,
        primary: rule.primary,
        mac: rule.mac,
        linux: rule.linux,
        win: rule.win,
        handler: terminalSendSequenceCommand,
        args: { text }
    });
}
if (isWindows) {
    registerSendSequenceKeybinding(String.fromCharCode('V'.charCodeAt(0) - 64 ), {
        when: ( (ContextKeyExpr.and(TerminalContextKeys.focus,  (ContextKeyExpr.equals(
            "terminalShellType",
            "pwsh"
        )),  (CONTEXT_ACCESSIBILITY_MODE_ENABLED.negate())))),
        primary: 2048  | 52
    });
}
registerSendSequenceKeybinding('\x1b[24~a', {
    when: ( (ContextKeyExpr.and(TerminalContextKeys.focus,  (ContextKeyExpr.equals(
        "terminalShellType",
        "pwsh"
    )), TerminalContextKeys.terminalShellIntegrationEnabled,  (CONTEXT_ACCESSIBILITY_MODE_ENABLED.negate())))),
    primary: 2048  | 10 ,
    mac: { primary: 256  | 10  }
});
registerSendSequenceKeybinding('\x1b[24~b', {
    when: ( (ContextKeyExpr.and(TerminalContextKeys.focus,  (ContextKeyExpr.equals(
        "terminalShellType",
        "pwsh"
    )), TerminalContextKeys.terminalShellIntegrationEnabled,  (CONTEXT_ACCESSIBILITY_MODE_ENABLED.negate())))),
    primary: 512  | 10
});
registerSendSequenceKeybinding('\x1b[24~c', {
    when: ( (ContextKeyExpr.and(TerminalContextKeys.focus,  (ContextKeyExpr.equals(
        "terminalShellType",
        "pwsh"
    )), TerminalContextKeys.terminalShellIntegrationEnabled,  (CONTEXT_ACCESSIBILITY_MODE_ENABLED.negate())))),
    primary: 1024  | 3
});
registerSendSequenceKeybinding('\x1b[24~d', {
    when: ( (ContextKeyExpr.and(TerminalContextKeys.focus,  (ContextKeyExpr.equals(
        "terminalShellType",
        "pwsh"
    )), TerminalContextKeys.terminalShellIntegrationEnabled,  (CONTEXT_ACCESSIBILITY_MODE_ENABLED.negate())))),
    mac: { primary: 1024  | 2048  | 17  }
});
registerSendSequenceKeybinding('\x1b[24~e', {
    when: ( (ContextKeyExpr.and(TerminalContextKeys.focus,  (ContextKeyExpr.equals(
        "terminalShellType",
        "pwsh"
    )), TerminalContextKeys.terminalShellIntegrationEnabled,  (CONTEXT_ACCESSIBILITY_MODE_ENABLED.negate()),  (ContextKeyExpr.equals(
        `config.${"terminal.integrated.shellIntegration.suggestEnabled" }`,
        true
    ))))),
    primary: 2048  | 10 ,
    mac: { primary: 256  | 10  }
});
registerSendSequenceKeybinding('\x1b[1;2H', {
    when: ( (ContextKeyExpr.and(TerminalContextKeys.focus,  (ContextKeyExpr.equals(
        "terminalShellType",
        "pwsh"
    ))))),
    mac: { primary: 1024  | 2048  | 15  }
});
registerSendSequenceKeybinding('\x12', {
    when: ( (ContextKeyExpr.and(TerminalContextKeys.focus, CONTEXT_ACCESSIBILITY_MODE_ENABLED))),
    primary: 2048  | 512  | 48 ,
    mac: { primary: 256  | 512  | 48  }
});
registerSendSequenceKeybinding('\x07', {
    when: TerminalContextKeys.focus,
    primary: 2048  | 512  | 37 ,
    mac: { primary: 256  | 512  | 37  }
});
if (isIOS) {
    registerSendSequenceKeybinding(String.fromCharCode('C'.charCodeAt(0) - 64 ), {
        when: ( (ContextKeyExpr.and(TerminalContextKeys.focus))),
        primary: 256  | 33
    });
}
registerSendSequenceKeybinding(String.fromCharCode('W'.charCodeAt(0) - 64 ), {
    primary: 2048  | 1 ,
    mac: { primary: 512  | 1  }
});
if (isWindows) {
    registerSendSequenceKeybinding(String.fromCharCode('H'.charCodeAt(0) - 64 ), {
        when: ( (ContextKeyExpr.and(TerminalContextKeys.focus,  (ContextKeyExpr.equals(
            "terminalShellType",
            "cmd"
        ))))),
        primary: 2048  | 1 ,
    });
}
registerSendSequenceKeybinding('\u001bd', {
    primary: 2048  | 20 ,
    mac: { primary: 512  | 20  }
});
registerSendSequenceKeybinding('\u0015', {
    mac: { primary: 2048  | 1  }
});
registerSendSequenceKeybinding(String.fromCharCode('A'.charCodeAt(0) - 64), {
    mac: { primary: 2048  | 15  }
});
registerSendSequenceKeybinding(String.fromCharCode('E'.charCodeAt(0) - 64), {
    mac: { primary: 2048  | 17  }
});
registerSendSequenceKeybinding('\u0000', {
    primary: 2048  | 1024  | 23 ,
    mac: { primary: 256  | 1024  | 23  }
});
registerSendSequenceKeybinding('\u001e', {
    primary: 2048  | 1024  | 27 ,
    mac: { primary: 256  | 1024  | 27  }
});
registerSendSequenceKeybinding('\u001f', {
    primary: 2048  | 90 ,
    mac: { primary: 256  | 90  }
});
setupTerminalCommands();
setupTerminalMenus();
registerColors();
